import React, { useState } from 'react';

import { Controller, useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';

import { useMutationForgotPassword } from 'api/mutations/forgotPassword.mutation';

import classes from 'components/App/AuthPublicPages/NewDesign/ForgotPassword/ForgotPassword.module.scss';
import { Layout } from 'components/App/AuthPublicPages/components/Layout/Layout';
import Button from 'components/DesignSystem/Button/Button';
import { TextInput } from 'components/DesignSystem/TextInput';
import { CustomizedFormErrorMessage } from 'components/common';

interface IForgotPasswordForm {
    email: string;
}

export const ForgotPassword = () => {
    const [message, setMessage] = useState<string>('');
    const [error, setError] = useState<string>('');
    const { mutate } = useMutationForgotPassword();
    const [loading, setLoading] = useState<boolean>(false);
    const form = useForm<IForgotPasswordForm>({
        defaultValues: {
            email: '',
        },
    });

    const handleSaveUseForm = (value) => {
        setLoading(true);
        mutate(
            { email: value.email },
            {
                onSuccess: () => {
                    setMessage(
                        `If an account exists matching the email address you provided (${value.email}), then you will receive an email with instructions on how to reset your password.`,
                    );
                },
                onError: (error) => {
                    setError(error?.response?.data || 'Something went wrong');
                },
                onSettled: () => {
                    setLoading(false);
                },
            },
        );
    };

    return (
        <Layout>
            <div className={classes.container}>
                <div className={classes.title}>{message === '' ? 'Forgot your password?' : 'Check your e-mail'}</div>
                <div className={classes.subTitle}>
                    {message === '' ? (
                        <>Enter your email and we'll send you a link to get back into your account.</>
                    ) : (
                        message
                    )}
                </div>

                <form onSubmit={form.handleSubmit(handleSaveUseForm)} autoComplete={'off'}>
                    <div className={classes.formRows}>
                        {message === '' && (
                            <div className={classes.row}>
                                <span className={classes.label}>Email</span>
                                <Controller
                                    render={({ field }) => <TextInput {...field} clearable={false} />}
                                    name={'email'}
                                    control={form.control}
                                />
                                {form.formState.errors.email && (
                                    <CustomizedFormErrorMessage text={form.formState.errors.email.message} />
                                )}
                                {error && <CustomizedFormErrorMessage text={error} />}
                            </div>
                        )}

                        <div className={classes.row}>
                            <Button disabled={loading} isLoading={loading} id={'login-button'} type={'submit'}>
                                {message === '' ? 'Send' : 'Resend e-mail'}
                            </Button>
                        </div>
                        <div className={classes.row}>
                            <Button component={Link} to={'/login'} variant={'tertiary'}>
                                Back to sign in
                            </Button>
                        </div>
                    </div>
                </form>
            </div>
        </Layout>
    );
};
